export function autoArrangeCards(cards) {
    const suits = ['spades', 'hearts', 'diamonds', 'clubs', 'jokers'];
    const rank = card => card.type === 'jokers' ? ['red', 'black', 'blue'].indexOf(card.rank) : Number(card.rank);
    return cards.map(card => ({ ...card, group: 0 })).sort((a, b) =>
        suits.indexOf(a.type) - suits.indexOf(b.type) || rank(a) - rank(b));
}
